const $window = $(window);

export const calcBackgroundVideoSize = () => {
  if ($window.width() > 1024) {
    const $video = $('.js-video-background');

    $video.each(function () {
      const $this = $(this);
      const $section =
        $this.parents('.section-split-video').length ? $this.parents('.section-split-video'): $this.parents('.section-video');
      // if video is in 50% width section
      if ($section.length) {
        const height = $this.parents('.section__aside').outerHeight();
        const finalHeight = height * 2 - height / 5;

        let $iframe = $this;

        if ($this.find('iframe').length) {
          $iframe = $this.find('iframe');
        }

        $iframe.css('min-width', 'auto');
        $iframe.css('min-width', finalHeight + 'px');
      }
    });
  } else {
    const $video = $('.js-video-background');

    $video.css('min-width', '');
  }
};
